// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/web-operation-list-schema',
  type: 'object',
  required: ['operationNumber', 'numberAdfOnDuty', 'totalStaffHours'],
  nullable: true,
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    alertedOn: {
      type: 'string',
      format: 'date-time',
    },
    description: {
      type: 'string',
      nullable: true,
    },
    link: {
      type: 'string',
      nullable: true,
    },
    operationNumber: {
      type: 'integer',
    },
    organisationId: {
      type: 'string',
      format: 'uuid',
    },
    organisationName: {
      type: 'string',
      nullable: true,
    },
    location: {
      type: 'string',
      nullable: true,
    },
    damageType: {
      type: 'string',
      nullable: true,
    },
    numberAdfOnDuty: {
      type: 'integer',
    },
    totalStaffHours: {
      type: 'number',
    },
  },
} as IJSONSchema;

export default schema;
